import { useState, ReactNode } from 'react';
import { useTheme } from '../context/ThemeContext';
import { AdminAuthProvider } from '../context/AdminAuthContext';
import AdminGuard from './AdminGuard';
import AdminSidebar from './AdminSidebar';
import AdminTopbar from './AdminTopbar';

interface Props {
  title: string;
  children: ReactNode;
}

function AdminLayoutInner({ title, children }: Props) {
  const [collapsed, setCollapsed] = useState(false);
  const { theme } = useTheme();
  const dark = theme === 'dark';

  return (
    <AdminGuard>
      <div className={`flex h-screen overflow-hidden ${dark ? 'bg-[#111D2B]' : 'bg-gray-50'}`}>
        <AdminSidebar collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} />
        <div className="flex-1 flex flex-col overflow-hidden">
          <AdminTopbar title={title} />
          <main data-scroll-root className="flex-1 overflow-y-auto p-6">
            {children}
          </main>
        </div>
      </div>
    </AdminGuard>
  );
}

export default function AdminLayout({ title, children }: Props) {
  return (
    <AdminAuthProvider>
      <AdminLayoutInner title={title} children={children} />
    </AdminAuthProvider>
  );
}
